import { DocumentStatus, GenericObject, copyFields, fixDates } from '@synergy/models';
import { Media } from '@synergy/models';

import { AccountPurchase } from './account-purchase';
import { Contact } from './contact';
import { OfferStatus } from './enums/offer-status';
import { User } from './user';

export class Inquiry {
    public id!: number;
    public number!: string;
    public title!: string;
    public noteToSupplier?: string;
    public accountPurchases!: AccountPurchase[];
    public media!: Media[];
    public dueDate?: Date;
    public endDate!: Date;
    public isAuction?: boolean;
    public responsibleContact?: Contact;
    public createdBy!: User;
    public updateBy!: User;
    public createdAt!: Date;
    public updatedAt!: Date;
    public status!: DocumentStatus;
    public hasTransitions!: boolean;

    public get isStatusDeclined(): boolean {
        return (
            this.accountPurchases &&
            this.accountPurchases.some(
                accountPurchase =>
                    accountPurchase.offers &&
                    accountPurchase.offers.some(offer => offer.status === OfferStatus.Declined)
            )
        );
    }

    public get isStatusSubmitted(): boolean {
        return (
            this.accountPurchases &&
            this.accountPurchases.some(
                accountPurchase =>
                    accountPurchase.offers && accountPurchase.offers.some(offer => offer.status !== OfferStatus.Created)
            )
        );
    }

    public get isStatusCreated(): boolean {
        return (
            this.accountPurchases &&
            this.accountPurchases.some(
                accountPurchase =>
                    accountPurchase.offers && accountPurchase.offers.some(offer => offer.status === OfferStatus.Created)
            )
        );
    }

    public get canBeDeclined(): boolean {
        return (
            (this.isAuction && this.status === DocumentStatus.Ongoing) ||
            (this.isStatusCreated && this.status === DocumentStatus.Ongoing)
        );
    }

    public static fromPlainObject(object: GenericObject): Inquiry {
        const inquiry = new Inquiry();

        copyFields(object, inquiry);

        if (object['responsibleContact']) {
            inquiry.responsibleContact = Contact.fromPlainObject(object['responsibleContact']);
        }

        if (object['media']) {
            inquiry.media = object['media'].map(Media.fromPlainObject);
        }

        if (object['accountPurchases']) {
            inquiry.accountPurchases = object['accountPurchases'].map(AccountPurchase.fromPlainObject);
        }

        if (object['createdBy']) {
            inquiry.createdBy = User.fromPlainObject(object['createdBy']);
        }

        if (object['updateBy']) {
            inquiry.updateBy = User.fromPlainObject(object['updateBy']);
        }

        fixDates(inquiry, ['createdAt', 'updatedAt', 'dueDate', 'endDate']);

        return inquiry;
    }
}
